import useAuth from 'src/hooks/useAuth';
import { UserCompanyRole } from 'src/types';

const useHasUserReadOnlyAccess = () => {
    const { user } = useAuth();
    return user?.apaduaRole === UserCompanyRole.ReadOnly;
};

export default useHasUserReadOnlyAccess;
